<template>
  <div>
    <nav class="panel" v-if="feeds">
      <p class="panel-heading">Select a Feed to Get Started</p>
      <p class="panel-tabs">
        <a
          @click="selectedType = tab"
          :class="{'is-active': tab === selectedType}"
          :key="tab"
          v-for="tab in tabs"
        >{{tab}}</a>
      </p>
      <p class="panel-tabs">
        <a
          @click="selectedStatus = tab"
          :class="{'is-active': tab === selectedStatus}"
          :key="tab"
          v-for="tab in statusTabs"
        >{{tab}}</a>
      </p>
      <!-- featured -->
      <router-link :to="`explorer/spotlight/${selectedType}`" class="panel-block" v-if="selectedType !== 'Minor'">
        <div class="media">
          <div class="media-left">
            <figure class="image is-48x48">
              <img src="https://supersport.azureedge.net/web-assets/misc/star.png">
            </figure>
          </div>
          <div class="media-content">
            <p class="title is-5">{{selectedType === 'All' ? 'Main' : selectedType}}</p>
            <p class="subtitle is-6">{{selectedType === 'All' ? 'Main' : selectedType}} Spotlight Section</p>
          </div>
        </div>
      </router-link>
      <!-- tournaments -->
      <router-link
        :to="`explorer/${feed.type.toLowerCase()}/${encodeURIComponent(feed.slug)}`"
        class="panel-block"
        :key="feed.id"
        v-for="feed in feeds"
      >
        <div class="media">
          <div class="media-left" v-if="feed.image_url">
            <figure class="image is-48x48">
              <img @error="imageError" :src="feed.image_url" :alt="feed.name">
            </figure>
          </div>
          <div class="media-content">
            <p class="title is-5">{{feed.name}}</p>
            <p class="subtitle is-6">{{feed.type}}</p>
          </div>
        </div>
      </router-link>
    </nav>
    <loading v-else></loading>
  </div>
</template>

<script>
import { GET_FEEDS } from "@/store/actions";
import Loading from "@/components/Loading";

export default {
  name: "explorer",
  components: {
    Loading
  },
  data() {
    return {
      tabs: [
        "All",
        "Football",
        "Rugby",
        "Cricket",
        "Tennis",
        "Golf",
        "Motorsport",
        "Minor"
      ],
      statusTabs: ["All", "Enabled", "Disabled"],
      selectedType: "All",
      selectedStatus: "All"
    };
  },
  computed: {
    data() {
      return this.$store.state.feeds.data;
    },
    feeds() {
      let { data, selectedType, selectedStatus } = this;

      if (!data) {
        return data;
      }

      let feedItems = [...data];

      if (selectedType !== "All") {
        feedItems = feedItems.filter(x => x.type === selectedType);
      }

      if (selectedStatus !== "All") {
        feedItems = feedItems.filter(
          x => x.enabled === (selectedStatus === "Enabled")
        );
      }

      return feedItems;
    }
  },
  mounted() {
    if (!this.data || this.data.length <= 0) {
      this.$store.dispatch(GET_FEEDS);
    }
  },
  methods: {
    imageError(e) {
      e.target.src = "https://www.supersport.com/images/placeholder-flag.png";
    }
  }
};
</script>
